export default "<textarea *ngIf=\"idToken\" readonly>{{ idToken }}</textarea>\r\n<button *ngIf=\"idToken\" (click)=\"copy()\">copy</button>"